import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateIfNeeded } from "~/lib/helpers.js";
import { getBaseData } from "~/redux/flights/flights.actions.js";
import { getVliegerData, profileAction } from "~/redux/persist/persist.actions.js";

export function useSyncData() {
    const dispatch = useDispatch();
    const flights = useSelector((state) => state.flights);

    const syncData = useCallback(async () => {
        // hard sync of all data
        await dispatch(getBaseData());
        await dispatch(profileAction());
        await dispatch(getVliegerData())
        await dispatch({ type: 'RESET_MATERIAAL_STATE' });
    }, [dispatch]);

    const updateBase = useCallback(async () => {
        await dispatch(getBaseData());
        await dispatch({ type: 'RESET_MATERIAAL_STATE' });
    }, [dispatch]);

    const updateBaseIfRequired = useCallback(() => {
        updateIfNeeded(flights.lastUpdatedBaseData, () =>
            dispatch(getBaseData())
        );
    }, [flights.lastUpdatedBaseData, dispatch]);

    return {
        sync: syncData,
        updateBase,
        updateBaseIfRequired
    }
}

export function usePermission() {
    const persist = useSelector((state) => state.persist);

    return {
        can(role) {
            return persist.profile.app_permissions.includes(role);
        }
    }
}